import React from "react";
import "react-table-v6/react-table.css";
import {
  Dropdown,
  Menu, 
  Tab,
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import matrix from "../../Images/matrix-logo.png";
import MainView from "./MainView.jsx";
import DisbursementTabView from "./DisbursementTabView.jsx";
import DashboardTabView from "./DashboardTabView.jsx";
import { Segment } from "semantic-ui-react";

class TabView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBarVisible: true,
    };
  }

  
  render() {
    console.log(this.props.auth.role,'role')
    if(this.props.auth.role === 'admin'){
     
   
        var admin = [
          {
            menuItem: { key: "users", icon: "cloud upload", content: "Inputs" },
            render: () => (
              <Tab.Pane>
                <MainView />
              </Tab.Pane>
            ),
          }
        ];
      
      
  
    }
    else{
      var admin = [
        {
          menuItem: { key: "users", icon: "cloud upload", content: "Inputs" },
          render: () => (
            <Tab.Pane>
              <MainView />
            </Tab.Pane>
          ),
        },
        {
          menuItem: { key: "disbursement", icon: "hourglass start", content: "Disbursement Tab" },
          render: () => (
            <Tab.Pane>
              <DisbursementTabView />
            </Tab.Pane>
          ),
        },
        {
          menuItem: { key: "dissummary", icon: "dashboard", content: "Dashboard" },
          render: () => (
            <Tab.Pane>
              <DashboardTabView />
            </Tab.Pane>
          ),
        },
      ];
  
    }
    
    return (
      <div style={{ height: "100%",width:"100%" }}>
        <Tab panes={admin} />    
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    vendor: state.vendor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TabView)
);
